import { Badge, Button, Card, Divider, notification, Typography } from 'antd';
import Meta from 'antd/es/card/Meta';
import { useContext, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import lendingImage from '../../Assets/lending.png';
import pfmImage from '../../Assets/pfm.png';
import {
  setPfmType,
  setTempateType,
  setUserId,
  USERSESSIONOBJECT,
} from '../../Utils/storageUtils';
import './index.css';
import { AppContext } from '../../App';

const LandingPage: React.FC<{
  onClick: (selectedType: number, type: string) => void;
  isError: boolean;
  setIsError: any;
  setShowSideBar: any;
}> = ({ onClick, isError, setIsError, setShowSideBar }) => {
  const [pfmType, setPfmTypeState] = useState('');
  const [loading, setLoading] = useState(false);
  const [isDirectLink, setIsDirectLink] = useState(true);
  const [type, setType] = useState('');
  const [selectedCard, setSelectedCard] = useState(1);
  const [queryParam] = useSearchParams();
  const { isLoanJourneyDone }: any = useContext(AppContext);
  function generateRandomNumber() {
    // Generate the first digit (6, 7, 8, or 9)
    const firstDigit = Math.floor(Math.random() * 4) + 6;

    // Generate the remaining 9 digits
    let remainingDigits = '';
    for (let i = 0; i < 9; i++) {
      remainingDigits += Math.floor(Math.random() * 10);
    }

    // Combine the first digit with the remaining digits
    const randomNumber = firstDigit + remainingDigits;
    return randomNumber;
  }

  useEffect(() => {
    if (queryParam) {
      const userName = queryParam.get('userName');
      const loanType = queryParam.get('loanType');
      if (userName) {
        switch (userName) {
          case 'newUser':
            console.log('dfdfd');
            setShowSideBar(true);
            setLoading(true);
            setIsDirectLink(true);
            setUserId(generateRandomNumber());
            setType('profile_1_new');
            setTempateType('PFM_BANKS');
            setPfmTypeState('profile_1');
            setPfmType('profile_1');
            break;
          case 'Rajesh':
            setLoading(true);
            setIsDirectLink(true);
            setUserId('6351718812');
            setType('profile_1');
            setPfmTypeState('profile_1');
            setPfmType('profile_1');
            break;
          case 'Ashok':
            setLoading(true);
            setIsDirectLink(true);
            setUserId('6351718812');
            setType('profile_2');
            setPfmTypeState('profile_2');
            setPfmType('profile_2');
            break;
          case 'Shahnawaz':
            setLoading(true);
            setIsDirectLink(true);
            setUserId('6351718812');
            setType('profile_3');
            setPfmTypeState('profile_3');
            setPfmType('profile_3');
            break;
          case 'Pankaj':
            setLoading(true);
            setIsDirectLink(true);
            setUserId('6351718812');
            setType('profile_4');
            setPfmTypeState('profile_4');
            setPfmType('profile_4');
            break;
          case 'Shankar':
            setLoading(true);
            setIsDirectLink(true);
            setUserId('6351718812');
            setType('profile_5');
            setPfmTypeState('profile_5');
            setPfmType('profile_5');
            break;
          default:
            setShowSideBar(true);
            setIsDirectLink(false);
            break;
        }
      } else if (loanType && !isLoanJourneyDone.current) {
        setSelectedCard(0);
        setShowSideBar(true);
        isLoanJourneyDone.current = true;
        switch (loanType) {
          case 'home':
            setLoading(true);
            setIsDirectLink(true);
            setUserId(generateRandomNumber());
            setType('home');
            setTempateType('HOME_LOAN');
            break;
          case 'car':
            setLoading(true);
            setIsDirectLink(true);
            setUserId(generateRandomNumber());
            setType('home');
            setTempateType('CAR_LOAN');
            break;
          case 'personal':
            setLoading(true);
            setIsDirectLink(true);
            setUserId(generateRandomNumber());
            setType('home');
            setTempateType('PERSONAL_LOAN');
            break;

          default:
            setShowSideBar(true);
            setIsDirectLink(false);
            break;
        }
      } else {
        setShowSideBar(true);
        setIsDirectLink(false);
      }
    }
  }, [queryParam]);

  useEffect(() => {
    if (isError) {
      setLoading(false);
      notification.error({
        message: 'Something went wrong. Please try again later.',
        duration: 3,
      });
      setIsError(false);
    }
  }, [isError]);

  const LocalesData: any = {
    profile_1: () => import('../../Static/data/profile_1.json'),
    profile_2: () => import('../../Static/data/profile_2.json'),
    profile_3: () => import('../../Static/data/profile_3.json'),
    profile_4: () => import('../../Static/data/profile_4.json'),
    profile_5: () => import('../../Static/data/profile_5.json'),
  };

  useEffect(() => {
    if (type !== '' && selectedCard === 1) {
      LocalesData[pfmType]().then((res: any) => {
        USERSESSIONOBJECT.data = res.default.body;
        onClick(selectedCard, type);
      });
    } else if (selectedCard === 0) {
      onClick(selectedCard, type);
    }
  }, [type]);

  return (
    <div
      className='infoSection'
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        padding: '25px 0px',
        boxSizing: 'border-box',
      }}
    >
      {isDirectLink ? (
        <></>
      ) : (
        <>
          <div
            style={{
              display: 'flex',
              width: '90%',
              justifyContent: 'space-between',
            }}
          >
            {[
              {
                title: 'Good Bank AA TSP',
                description: 'Begin your lending jouney with us',
                disabled: false,
              },
              {
                title: 'Good Bank PFM TSP',
                description: 'Kepp track of your financials with us',
                disabled: false,
              },
            ].map((i: any, index: number) => {
              return i.disabled ? (
                <Badge.Ribbon
                  rootClassName='ribbonRoot'
                  style={{ marginTop: -20 }}
                  text='Coming soon...'
                  color='#939598'
                >
                  <Card
                    hoverable
                    className={`${
                      selectedCard === index
                        ? 'lendingSelectionSelected'
                        : 'lendingSelectionNotSelected'
                    } lendingSelection`}
                    cover={
                      <img
                        src={pfmImage}
                        style={{ marginTop: 10, height: 50 }}
                      ></img>
                    }
                  >
                    <Meta
                      className={`${
                        selectedCard === index
                          ? 'metaContentSelected'
                          : 'metaContentNotSelected'
                      }`}
                      title={i.title}
                      // description={i.description}
                    />
                  </Card>
                </Badge.Ribbon>
              ) : (
                <Card
                  onClick={() => {
                    setSelectedCard(index);
                  }}
                  hoverable
                  className={`${
                    selectedCard === index
                      ? 'lendingSelectionSelected'
                      : 'lendingSelectionNotSelected'
                  } lendingSelection ${i.disabled ? '' : 'width48'}`}
                  cover={
                    <img
                      src={lendingImage}
                      style={{ marginTop: 10, height: 50 }}
                    ></img>
                  }
                >
                  <Meta
                    className={`${
                      selectedCard === index
                        ? 'metaContentSelected'
                        : 'metaContentNotSelected'
                    }`}
                    title={i.title}
                    //   description={i.description}
                  />
                </Card>
              );
            })}
          </div>

          <Card className={`lendingSelection detailsCard`}>
            <div
              className='overFlow'
              style={{
                display: 'flex',
                width: '100%',
                alignItems: 'flex-start',
                flexDirection: 'column',
                height: '100%',
              }}
            >
              <Typography.Text
                style={{ color: 'black', fontSize: 18, fontWeight: 500 }}
              >
                {selectedCard === 0
                  ? 'Good bank lending!!!'
                  : 'Good bank PFM!!!'}{' '}
              </Typography.Text>

              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  width: '100%',
                  alignItems: 'center',
                  flexDirection: 'column',
                  flex: 1,
                  marginTop: 10,
                }}
              >
                <Button
                  className='buttonPfm'
                  style={{
                    background: 'transparent',
                    color: 'black',
                    borderRadius: 10,
                    height: 50,
                  }}
                  disabled={loading && type !== 'profile_1_new'}
                  loading={loading && type === 'profile_1_new'}
                  onClick={async () => {
                    setUserId(generateRandomNumber());
                    setType('profile_1_new');
                    setLoading(true);
                    setTempateType(
                      selectedCard === 0 ? 'HOME_LOAN' : 'PFM_BANKS'
                    );
                    if (selectedCard === 1) {
                      setPfmTypeState('profile_1');
                      setPfmType('profile_1');
                    }
                  }}
                >
                  {selectedCard === 0 ? 'Home Loan' : 'New PFM user'}
                </Button>

                {selectedCard === 1 ? <Divider /> : <></>}

                <Button
                  disabled={loading && type !== 'profile_1'}
                  loading={loading && type === 'profile_1'}
                  className='buttonPfm'
                  style={{
                    background: 'transparent',
                    color: 'black',
                    borderRadius: 10,
                    height: selectedCard === 0 ? 50 : 'auto',
                    minWidth: '272px',
                  }}
                  onClick={() => {
                    setUserId('6351718812');
                    setType('profile_1');
                    if (selectedCard === 1) {
                      setPfmTypeState('profile_1');
                      setPfmType('profile_1');
                    }
                    setLoading(true);
                    setTempateType(selectedCard === 0 ? 'CAR_LOAN' : 'PFM');
                  }}
                >
                  {selectedCard === 0 ? (
                    'Car Loan'
                  ) : (
                    <Card
                      className='cardPersona'
                      style={{ boxShadow: 'none' }}
                      bordered={false}
                    >
                      <Meta
                        title='User1'
                        description='(Salaried,Uninsured,Investor)'
                      />
                    </Card>
                  )}
                </Button>

                {selectedCard === 0 ? (
                  <>
                    <Button
                      disabled={loading && type !== 'personal'}
                      loading={loading && type === 'personal'}
                      className='buttonPfm'
                      style={{
                        background: 'transparent',
                        color: 'black',
                        borderRadius: 10,
                        height: 50,
                      }}
                      onClick={() => {
                        setUserId(generateRandomNumber());
                        setType('personal');
                        setLoading(true);
                        setTempateType('PERSONAL_LOAN');
                      }}
                    >
                      Personal Loan
                    </Button>

                    <Button
                      disabled={loading}
                      className='buttonPfm'
                      style={{
                        background: 'transparent',
                        color: 'black',
                        borderRadius: 10,
                        height: 50,
                      }}
                      onClick={() => {
                        window.open(
                          'https://fiupreprod.ignosis.ai/fiu/consent-requests/',
                          '_blank'
                        );
                      }}
                    >
                      TSP Admin Login
                    </Button>
                  </>
                ) : (
                  <>
                    <Button
                      disabled={loading && type !== 'profile_2'}
                      loading={loading && type === 'profile_2'}
                      className='buttonPfm'
                      style={{
                        background: 'transparent',
                        color: 'black',
                        borderRadius: 10,
                        minWidth: '272px',
                        height: 'auto',
                      }}
                      onClick={() => {
                        setUserId('6351718812');
                        setType('profile_2');
                        if (selectedCard === 1) {
                          setPfmTypeState('profile_2');
                          setPfmType('profile_2');
                        }
                        setLoading(true);
                        setTempateType(selectedCard === 0 ? 'CAR_LOAN' : 'PFM');
                      }}
                    >
                      {selectedCard === 0 ? (
                        'Car Loan'
                      ) : (
                        <Card
                          className='cardPersona'
                          style={{ boxShadow: 'none' }}
                          bordered={false}
                        >
                          <Meta
                            title='User2'
                            description='(Non Salaried,Forex)'
                          />
                        </Card>
                      )}
                    </Button>

                    <Button
                      disabled={loading && type !== 'profile_3'}
                      loading={loading && type === 'profile_3'}
                      className='buttonPfm'
                      style={{
                        background: 'transparent',
                        color: 'black',
                        borderRadius: 10,
                        height: 'auto',
                        minWidth: '272px',
                      }}
                      onClick={() => {
                        setUserId('6351718812');
                        setType('profile_3');
                        if (selectedCard === 1) {
                          setPfmTypeState('profile_3');
                          setPfmType('profile_3');
                        }
                        setLoading(true);
                        setTempateType(selectedCard === 0 ? 'CAR_LOAN' : 'PFM');
                      }}
                    >
                      {selectedCard === 0 ? (
                        'Car Loan'
                      ) : (
                        <Card
                          className='cardPersona'
                          style={{ boxShadow: 'none' }}
                          bordered={false}
                        >
                          <Meta
                            title='User3'
                            description='(Salaried,Shopper,Foodie)'
                          />
                        </Card>
                      )}
                    </Button>

                    <Button
                      disabled={loading && type !== 'profile_4'}
                      loading={loading && type === 'profile_4'}
                      className='buttonPfm'
                      style={{
                        background: 'transparent',
                        color: 'black',
                        borderRadius: 10,
                        height: 'auto',
                        minWidth: '272px',
                      }}
                      onClick={() => {
                        setUserId('6351718812');
                        setType('profile_4');
                        if (selectedCard === 1) {
                          setPfmTypeState('profile_4');
                          setPfmType('profile_4');
                        }
                        setLoading(true);
                        setTempateType(selectedCard === 0 ? 'CAR_LOAN' : 'PFM');
                      }}
                    >
                      {selectedCard === 0 ? (
                        'Car Loan'
                      ) : (
                        <Card
                          className='cardPersona'
                          style={{ boxShadow: 'none' }}
                          bordered={false}
                        >
                          <Meta
                            title='User4'
                            description='(Salaried, Parent, Long Term Investor)'
                          />
                        </Card>
                      )}
                    </Button>

                    <Button
                      disabled={loading && type !== 'profile_5'}
                      loading={loading && type === 'profile_5'}
                      className='buttonPfm'
                      style={{
                        background: 'transparent',
                        color: 'black',
                        borderRadius: 10,
                        height: 'auto',
                        minWidth: '272px',
                      }}
                      onClick={() => {
                        setUserId('6351718812');
                        setType('profile_5');
                        if (selectedCard === 1) {
                          setPfmTypeState('profile_5');
                          setPfmType('profile_5');
                        }
                        setLoading(true);
                        setTempateType(selectedCard === 0 ? 'CAR_LOAN' : 'PFM');
                      }}
                    >
                      {selectedCard === 0 ? (
                        'Car Loan'
                      ) : (
                        <Card
                          className='cardPersona'
                          style={{ boxShadow: 'none' }}
                          bordered={false}
                        >
                          <Meta
                            title='User5'
                            description='(Non Salaried,Home Loan,Business)'
                          />
                        </Card>
                      )}
                    </Button>
                  </>
                )}
              </div>
            </div>
          </Card>
        </>
      )}
    </div>
    // {/* </div> */}
  );
};

export default LandingPage;
